import axios from 'axios';
import { TENANT_ID, URL_BACKEND_API } from "../../environments/environment";
import { dataDecrypt } from '../../utils/dataDecrypt';
import { dataEncrypt } from '../../utils/dataEncrypt';
import { render } from '../../utils/render';
export const postLEGALS = async (requestBody) => {
    try {
        const { data } = await axios.post(`${render(URL_BACKEND_API)}/partnerManagement/getDisclaimer`, dataEncrypt(requestBody), { headers: { 'tenant-id': render(TENANT_ID), 'Content-Type': 'application/json', } });
        return dataDecrypt(data);
    } catch (error) {
        return error;
    }
};
